import { Box, Typography } from "@material-ui/core";
import * as React from "react";

import { CustomButton } from "@/components/Button";
import { PropertyEditHistoryRow } from "@/components/property_edit/PropertyEditHistoryRow";

interface Props {
  title: string;
  contents: { label: string; value: string }[];
  onClickShowMoreHistory: () => void;
}

export const LatestHistoryContent: React.FC<Props> = ({ title, contents, onClickShowMoreHistory }) => {
  const amount = contents.find((item) => item.label === "金額");
  const start = contents.find((item) => item.label === "支払開始月");
  if (amount)
    return (
      <PropertyEditHistoryRow
        label={title}
        value={amount.value === "-円" ? undefined : amount.value}
        since={start?.value.includes("-") ? undefined : start?.value ? `${start.value}〜` : undefined}
        onClick={onClickShowMoreHistory}
      />
    );
  const interest = title === "借入利率変動";
  const prepayment = title === "繰上返済";
  const insurance = title.includes("保険");
  return (
    <Box mb={4}>
      {title && (
        <Typography component="h3" data-edit-section>
          {interest ? "利率" : title === "借入条件" ? "借入の条件" : title}
        </Typography>
      )}
      {interest ? (
        <PropertyEditHistoryRow
          label="借入利率（年利）"
          value={contents.find((item) => item.label.includes("利率"))?.value}
          since={contents.find((item) => item.label.includes("月"))?.value}
          onClick={onClickShowMoreHistory}
        />
      ) : prepayment ? (
        <PropertyEditHistoryRow
          label={contents[0]?.value || "繰上返済"}
          value={contents
            .slice(1)
            .map((item) => item.value)
            .join("・")}
          onClick={onClickShowMoreHistory}
        />
      ) : (
        contents.map((item, index) => (
          <PropertyEditHistoryRow
            key={index}
            label={insurance ? item.label.replace(title, "保険") : item.label}
            value={item.value}
            onClick={onClickShowMoreHistory}
          />
        ))
      )}
      {(insurance || prepayment) && (
        <Box mt={1}>
          <CustomButton type="button" customVariant="outlinedPrimary" buttonSize="M" onClick={onClickShowMoreHistory}>
            {insurance ? "更新した保険を追加" : "繰上返済を追加"}
          </CustomButton>
        </Box>
      )}
    </Box>
  );
};
